import TableModel from '../../datasource/table';
import PipelineStepModel from './pipeline_step_model';

export default class MergeStepModel extends PipelineStepModel {
    apply(tables) {
        if (tables.every(table => table)) {
            const table = new TableModel(tables[0]);
            for (const column of tables[1].columns) {
                table.addColumn(column);
            }
            return {table};
        }
        return {error: true, table: null}
    }
}
